import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom'

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';

import logo from '../scop_logo.png';
import './Header.css';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {value: '', results: null};
    
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        const q = this.state.value;
        const url = process.env.PUBLIC_URL + '/search?t=txt;q=' + q; 
        this.props.history.push(url);
    }

    render() {
        const route =   this.props.location.pathname;
     //   console.log('route: ', route);
        if (route.match(/\/sview\//)) {
          return (<></>)
        }
        
        return (
          <div>
            <Navbar bg="light" expand="lg" id="navbar">
            <Navbar.Brand><Link to={`${process.env.PUBLIC_URL}`}><img src={logo} alt="SCOP logo" className="d-inline-block align-top logo"/></Link></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Link className="ml-5" to={`${process.env.PUBLIC_URL}/about`}>About</Link>
                <Link className="ml-5" to={`${process.env.PUBLIC_URL}/contact`}>Contact</Link>
                <Link className="ml-5" to={`${process.env.PUBLIC_URL}/download`}>Download</Link> 
              </Nav>
              <Form inline onSubmit={this.handleSubmit}>
                <FormControl onChange={this.handleChange} id="searchbox" type="text" placeholder="Search SCOP by text or ID" className="mr-sm-2" />
              </Form>
            </Navbar.Collapse>
          </Navbar>
        </div>
        )  
    }   
}

export default withRouter(Header);
